module.exports = __webpack_public_path__ + "media/images/countryrect/ye-94609e273f85b0b1e527422ccdb70e61.svg";